import { Row } from 'react-table';

import { ITableRow } from '../types';

export default function sortByName<T extends ITableRow>(
  firstRow: Row<T>,
  secondRow: Row<T>
): number {
  const {
    original: { familyName: firstFamilyName, givenName: firstGivenName },
  } = firstRow;
  const {
    original: { familyName: secondFamilyName, givenName: secondGivenName },
  } = secondRow;

  if (firstFamilyName > secondFamilyName) {
    return 1;
  }
  if (secondFamilyName > firstFamilyName) {
    return -1;
  }
  return firstGivenName >= secondGivenName ? 1 : -1;
}
